var _defs, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _path2, _path3, _path4, _path5, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgReportsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reports-image",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 76,
    height: 76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M620.689,348.079c-7.419.491-7.386,8.613-7.386,8.613V395.5h28.962V356.692s.137-8.149,7.35-8.613Z",
    transform: "translate(-613.303 -348.079)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.078,
    y1: -0.045,
    x2: 0.007,
    y2: 1.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#418079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ae2b0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 24.115,
    height: 27.791,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 24.053,
    height: 11.778,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M677.3,360.774H648.377c-7.419.491-7.386,8.613-7.386,8.613V408.2h28.962V369.387s.137-8.149,7.35-8.613",
    transform: "translate(-614.219 -345.799)",
    fill: "#2fbc99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 0.334,
    height: 29.872,
    transform: "translate(24.754 24.078)",
    fill: "#2fbc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M986.809,26.461H969.142V16.735h17.667Zm-17.333-.332h17V17.067h-17Z",
    transform: "translate(-928.664 -16.04)",
    fill: "#2fbc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M195.337,212.946H177.67V200.712h17.667ZM178,212.614h17v-11.57H178Z",
    transform: "translate(-170.249 -192.381)",
    fill: "#2fbc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1393.927,739.946h-17.668v-9.762h17.668Zm-17.333-.332h17v-9.1h-17Z",
    transform: "translate(-1318.777 -699.876)",
    fill: "#2fbc99"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(25.616 14.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M.108.1,52.18.212l.13,57.833L.238,57.929Z",
    transform: "matrix(0.92, -0.391, 0.391, 0.92, -17.356, 7.218)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 19.893,
    height: 1.744,
    transform: "translate(29.419 24.587)",
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 16.986,
    height: 1.236,
    transform: "translate(29.419 28.621)",
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 8.539,
    height: 1.835,
    transform: "translate(29.419 31.883)",
    fill: "#e4e4e4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 8.831,
    height: 1.835,
    transform: "translate(40.481 31.883)",
    fill: "#e4e4e4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 13.603,
    height: 1.308,
    transform: "translate(29.419 35.417)",
    fill: "#e4e4e4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 15.327,
    height: 0.727,
    transform: "translate(29.419 38.687)",
    fill: "#dbdbdb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 18.43,
    height: 0.727,
    transform: "translate(29.419 41.958)",
    fill: "#e4e4e4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M711.521,1092.268h-8.664v-4.122h8.664Zm-8.539-.125H711.4v-3.873h-8.413Z",
    transform: "translate(-673.501 -1042.979)",
    fill: "#dbdbdb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 7.752,
    height: 0.945,
    transform: "translate(40.097 45.229)",
    fill: "#e4e4e4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 5.495,
    height: 0.945,
    transform: "translate(40.097 47.228)",
    fill: "#e4e4e4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 16.575,
    height: 0.727,
    transform: "translate(29.419 51.77)",
    fill: "#e4e4e4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 8.731,
    height: 0.727,
    transform: "translate(29.419 55.041)",
    fill: "#e4e4e4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1464.9,834.6l-.854-1.39a.241.241,0,0,1,.081-.332.244.244,0,0,1,.334.08l.6.983,1.606-.944a.244.244,0,0,1,.333.085.241.241,0,0,1-.085.331Z",
    transform: "translate(-1402.861 -798.272)",
    fill: "#2fbc99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M1428.572,785.816a3.053,3.053,0,1,1,3.072-3.053,3.066,3.066,0,0,1-3.072,3.053m0-5.669a2.617,2.617,0,1,0,2.633,2.617,2.628,2.628,0,0,0-2.633-2.617",
    transform: "translate(-1365.961 -747.347)",
    fill: "#2fbc99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M1019.543,88.758l.06,1.283.512-.024-.1-2.152-2.212.1.024.509,1.337-.062-2.357,2.571-2.452-2.22-.345.377,2.831,2.564Z",
    transform: "translate(-971.657 -84.218)",
    fill: "#2fbc99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M239.327,256.664a1.159,1.159,0,0,0-.221-.179,2.557,2.557,0,0,0-.338-.184,2.784,2.784,0,0,0-.422-.151,2.452,2.452,0,0,0-.472-.08l-.006,1.72.159.034a7.426,7.426,0,0,1,.814.244,2.324,2.324,0,0,1,.613.326,1.321,1.321,0,0,1,.387.471,1.513,1.513,0,0,1,.136.678,1.641,1.641,0,0,1-.161.751,1.468,1.468,0,0,1-.441.518,1.974,1.974,0,0,1-.653.309,3.2,3.2,0,0,1-.8.11l0,.872h-.435l0-.889a4.237,4.237,0,0,1-1.144-.24,3.611,3.611,0,0,1-.993-.547l.429-.8a1.476,1.476,0,0,0,.267.217,3.061,3.061,0,0,0,.409.226,3.788,3.788,0,0,0,.514.193,3.309,3.309,0,0,0,.581.118l.006-1.72q-.05-.017-.1-.029c-.036-.008-.071-.018-.1-.029a7.085,7.085,0,0,1-.772-.248,1.935,1.935,0,0,1-.547-.313,1.222,1.222,0,0,1-.329-.429,1.413,1.413,0,0,1-.111-.594,1.743,1.743,0,0,1,.145-.722,1.583,1.583,0,0,1,.4-.543,1.914,1.914,0,0,1,.607-.355,2.838,2.838,0,0,1,.765-.16l0-.839h.435l0,.839a3.239,3.239,0,0,1,1,.219,3.637,3.637,0,0,1,.809.443Zm-2.759.207a.6.6,0,0,0,.245.524,2.388,2.388,0,0,0,.747.31l.005-1.637a1.216,1.216,0,0,0-.753.234.718.718,0,0,0-.244.568m2.407,2.766a.614.614,0,0,0-.291-.553,3.152,3.152,0,0,0-.818-.339l-.005,1.645a1.53,1.53,0,0,0,.824-.2.626.626,0,0,0,.29-.556",
    transform: "translate(-225.522 -243.838)",
    fill: "#2fbc99"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 6.939,
    height: 0.981,
    transform: "translate(16.456 11.814)",
    fill: "#b5b5b5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 5.454,
    height: 0.981,
    transform: "translate(16.456 13.957)",
    fill: "#b5b5b5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 6.119,
    height: 0.981,
    transform: "translate(16.456 16.101)",
    fill: "#b5b5b5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 4.958,
    height: 0.981,
    transform: "translate(66.956 33.627)",
    fill: "#b5b5b5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 5.563,
    height: 0.981,
    transform: "translate(66.956 35.771)",
    fill: "#b5b5b5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 6.308,
    height: 0.981,
    transform: "translate(49.952 2.924)",
    fill: "#b5b5b5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 4.958,
    height: 0.981,
    transform: "translate(49.952 5.067)",
    fill: "#b5b5b5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 5.563,
    height: 0.981,
    transform: "translate(49.952 7.211)",
    fill: "#b5b5b5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1363.731,976.846h-5.36v-.332h5.026v-5.939h.334Z",
    transform: "translate(-1301.636 -930.288)",
    fill: "#b5b5b5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M863.538,266.1H863.2v-1.728h11.629v-1.215h.334V264.7H863.538Z",
    transform: "translate(-827.15 -252.23)",
    fill: "#b5b5b5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M420.161,523.126h-6.1V510.049h.334v12.745h5.766Z",
    transform: "translate(-396.767 -488.878)",
    fill: "#b5b5b5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M1350.625,403.9h-.334v-3.952c0-.066-.429-7.646,6.008-8.749l.057.327c-6.144,1.053-5.736,8.338-5.731,8.411Z",
    transform: "translate(-1293.886 -374.958)",
    fill: "#2fbc99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M1645.892,717.732h-.334v-6.7h-7.238V710.7h7.572Z",
    transform: "translate(-1569.892 -681.198)",
    fill: "#2fbc99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M162,370.883h-6.872v-6.435h.334v6.1H162Z",
    transform: "translate(-148.647 -349.321)",
    fill: "#2fbc99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M950.364,5.066h-.334V0h8.529V.331h-8.194Z",
    transform: "translate(-910.35 0.001)",
    fill: "#2fbc99"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M1218.853,1305.477H1212.6v-.332h5.922v-9.428h.334Z",
    transform: "translate(-1161.95 -1241.935)",
    fill: "#2fbc99"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M1122.742,1247.183H1117.3v-5.413h5.447Zm-4.946-.5h4.445v-4.417H1117.8Z",
    transform: "translate(-1070.629 -1190.227)",
    fill: "#dbdbdb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M1140.673,1251.829l-1.913-1.792.573-.6,1.378,1.291,3.007-2.455.53.641Z",
    transform: "translate(-1091.198 -1196.455)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(25.616 34.082)",
    opacity: 0.24,
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M635.422,828.389a14.8,14.8,0,0,0-22.12-3.945V827.8A12.363,12.363,0,0,1,633.33,829.6a12.127,12.127,0,0,1,1.659,5.682c.006.152.009.3.009.454a12.219,12.219,0,0,1-6.134,10.6,12.374,12.374,0,0,1-15.562-2.646v3.362a14.584,14.584,0,0,0,2.878,1.842h13c.3-.148.6-.309.9-.48a14.6,14.6,0,0,0,5.343-20.019",
    transform: "translate(-613.302 -821.096)",
    fill: "#3f444f"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M.011.06,23.766.132l.012,4.034L.023,4.094Z",
    transform: "matrix(0.768, -0.64, 0.64, 0.768, -0.046, 72.87)",
    fill: "#418079"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M.008,0l1.269,0,.009,3.062-1.269,0Z",
    transform: "translate(18.6 58.131) rotate(-39.808)",
    fill: "#34665f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M395.614,843.1a14.787,14.787,0,0,0,20.144,5.31,14.6,14.6,0,0,0,5.343-20.019,14.787,14.787,0,0,0-20.144-5.31,14.6,14.6,0,0,0-5.343,20.019m2.093-1.208a12.2,12.2,0,0,1,4.466-16.731,12.359,12.359,0,0,1,16.836,4.438,12.131,12.131,0,0,1,1.659,5.682h0a12.22,12.22,0,0,1-6.125,11.049,12.359,12.359,0,0,1-16.836-4.438",
    transform: "translate(-377.178 -787.012)",
    fill: "#dbdbdb"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(19.436 36.487)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M465.352,887.589s12.827-9.679,24.053,3.228h0a12.131,12.131,0,0,0-1.659-5.682A12.359,12.359,0,0,0,470.91,880.7a12.209,12.209,0,0,0-5.558,6.892",
    transform: "translate(-465.352 -879.04)",
    fill: "#c2c2c2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsImage);
export default __webpack_public_path__ + "static/media/reports-image.cbe6c362982deaf4cfe5cb59b10d1d79.svg";
export { ForwardRef as ReactComponent };